// Resources related to GCP identity-aware proxy
import Button from '@material-ui/core/Button';
import React, { useCallback } from 'react';
import { appConfig } from 'config';
let iapAuthRequired = false;
export const AuthWithGoogleButton = () => {
    const handleClick = useCallback(() => {
        open(getIapAuthUrl());
    }, []);
    return React.createElement(Button, { onClick: handleClick }, "Auth with Google");
};
export function resetIapAuthRequired() {
    iapAuthRequired = false;
}
export function isIapAuthRequired() {
    return iapAuthRequired;
}
export function setIapAuthRequired() {
    iapAuthRequired = true;
}
export function isIapProtectedUrl(url) {
    return url ? url.includes('/admin/') : false;
}
function getIapAuthUrl() {
    return `${appConfig.api}/admin?gcp-iap-mode=DO_SESSION_REFRESH`;
}
